import React, { useState , useEffect} from "react";
import { withRouter, Link, useHistory } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { withWidth } from "@material-ui/core";

const Header = (props: any) => {
    console.log(`props 10.0`,props)
    const [docket, setDocket] = useState("");
    const setDocketCap = (e: any) => {
        setDocket(e.toUpperCase());
    };
    const history = useHistory()
    const { width } = props;
    const mobileView = ["sm", "xs"].includes(width);

    const trackDocket = () => {
        const BranchDocketRegex =  (str:any)=>{
          const branchDocketRegex = /^[A-Z]{2,5}[1-9]{1}[0-9]{9}$/;
          return branchDocketRegex.test(str);
        }
        const BrnachTrackingIdRegex =  (str:any)=>{
            const trakingIdRegex = /^[A-Z]{3,5}-[0-9]{3,5}-[0-9]{0,10}$/;
            return trakingIdRegex.test(str);
        }
        const CustomerDocketRegex =  (str:any)=>{
            const customerDocketRegex = /^[A-Z]{2,4}-[A-Z]{1,3}-[0-9]{1,5}$/;
            return customerDocketRegex.test(str);
        }
        
    if(BranchDocketRegex(docket) === true){
        alert("Tracking Number is Not Valid !")
          history.push({pathname:"/"})
          setDocket("")
        // history.push({pathname:"/TempTracking",
        // state:{
        //     from: "Customer-NotAuthenticated-BranchOrder",
        //     docketNumber: {docket},
        //     typeOfDocket: "Branch Docket"
        // }
        // })
    }
    else if(BrnachTrackingIdRegex(docket) === true){
        history.push({pathname:"/TempTracking",
        state:{
            from: "Customer-NotAuthenticated-BranchOrder",
            docketNumber: {docket},
            typeOfDocket: "Branch Order Tracking Id"
        }
        })
    }
    else if(CustomerDocketRegex(docket) === true){
        history.push({pathname:"/TempTracking",
        state:{
                from: "Customer-NotAuthenticated-CustomerOrder",
                docketNumber: {docket},
                typeOfDocket: "Customer Docket"
              }
            })
        }
    else if(CustomerDocketRegex(docket) === false || BrnachTrackingIdRegex(docket) === false || BranchDocketRegex(docket) === false){
        alert("Docket Number Or Tracking Number is Not Valid !")
        history.push({pathname:"/"})
    }
    };

    let mobileviewinitial = window.innerWidth > 770 ? false : true;
    const [ismobileview, setismobileview] = useState(mobileviewinitial);
    
    useEffect(() => {
        function handleresize() {
        if (window.innerWidth > 770) {
            setismobileview(false);
        } else {
            setismobileview(true);
        }
        }
        window.addEventListener("resize", handleresize);
        return () => {
        window.removeEventListener("resize", handleresize);
        };
    }, []);

    const customerError = {
        border : "0.2px solid red",
        marginTop : "1%"
    }

    return (
        <nav
            id="taptapheader"
            className={props?.deviceStatus ? "navbar navbar-custom navbar-fixed-top" : "navbar navbar-custom navbar-fixed-top-extra"}
            role="navigation"
        >
            <div id="wraper" style={{ border: "0.2px solid tr" }}>
                <div
                    style={{ width: mobileView ? "auto" : 1350 }}
                    className="container navigation"
                >
                    <div className="navbar-header page-scroll">
                        <button
                            type="button"
                            className="navbar-toggle"
                            data-toggle="collapse"
                            data-target=".navbar-main-collapse"
                        >
                            <i className="fa fa-bars"></i>
                        </button>
                        <a className="navbar-brand" href="/">
                            <img
                                src="../img/tap8.png"
                                alt=""
                                width="120"
                                height="30"
                            />
                        </a>
                    </div>

                    {/* <!-- Collect the nav links, forms, and other content for toggling --> */}
                    <div className={ismobileview ? "collapse navbar-right navbar-main-collapse" : "collapse navbar-collapse navbar-right navbar-main-collapse"}>
                        <ul className="nav navbar-nav" style={{border : ismobileview ? "0.2px solid transparent" : "" , height : ismobileview ? "785px" : "" , 
                                fontSize : ismobileview ? "large" : ""}}>
                            {ismobileview ? 
                                <li style={{fontSize : "xx-large" , padding : "4.5% 7.5%"}}>
                                    <div onClick={() => history?.push("/aboutUs")}>About Us</div>
                                </li>
                                :
                                <li className="dropdown">
                                <Link to="/aboutUs">About Us</Link>
                                </li>
                            }
                            {ismobileview ? 
                                <li
                                    style={{fontSize : "xx-large" , padding : "4.5% 7.5%"}}
                                    // className=" wow fadeInRight"
                                    // data-wow-delay="0.6s"
                                >
                                    <div onClick={() => history?.push("/partners")}>Partners</div>
                                </li>
                                :
                                <li
                                    className=" wow fadeInRight"
                                    data-wow-delay="0.6s"
                                >
                                <Link to="/partners">Partners</Link>
                            </li>
                            }

                            {ismobileview ? 
                                <li
                                    style={{fontSize : "xx-large" , padding : "4.5% 7.5%"}}
                                    // className=" wow fadeInRight"
                                    // data-wow-delay="0.6s"
                                >
                                    <div onClick={() => history?.push("/customer")}>Customer</div>
                                </li>    
                                :
                                <li
                                    className=" wow fadeInRight"
                                    data-wow-delay="0.6s"
                                >
                                    <Link to="/customer">Customer</Link>
                                </li>
                            }
                            
                            {ismobileview ? 
                                <li
                                    style={{fontSize : "xx-large" , padding : "4.5% 7.5%"}}
                                    // className=" wow fadeInRight"
                                    // data-wow-delay="0.6s"
                                >
                                    <div onClick={() => history?.push("/kabra-express/our-networks")}>
                                        Our Networks
                                    </div>
                                </li>
                                :
                                <li
                                    className=" wow fadeInRight"
                                    data-wow-delay="0.6s"
                                >
                                    <Link to="/kabra-express/our-networks">
                                        Our Networks
                                    </Link>
                                </li>
                            }

                            {ismobileview ?
                                <li
                                    style={{fontSize : "xx-large" , padding : "4.5% 7.5%"}}
                                    // className=" wow fadeInRight"
                                    // data-wow-delay="0.6s"
                                >
                                    <div onClick={() => history?.push("/assist")}>Assist</div>
                                </li>
                                : 
                                <li
                                    className=" wow fadeInRight"
                                    data-wow-delay="0.6s"
                                >
                                    <Link to="/assist">Assist</Link>
                                </li>
                            }
                            {/* <li
                                className=" wow fadeInRight"
                                data-wow-delay="0.6s"
                            >
                                <Link to="/careers">
                                    Career
                                </Link>
                            </li> */}
                            {ismobileview ? 
                            <li
                                style={{fontSize : "xx-large" , padding : "4.5% 7.5%"}}
                                // className="wow fadeInRight dropdownOthersMobileBox"
                                // data-wow-delay="0.6s"
                            >
                                <div>
                                <div>
                                    Others
                                </div>

                                <div className="dropdown-content">
                                    <Link to="/careers">Careers</Link>
                                    <Link to="/insurance">Insurance</Link>
                                    <Link to="/store">Store</Link>
                                    <Link to="/second-hand-vehicle">Buy / Sell Vehicle</Link>
                                </div>
                                </div>
                            </li>
                            :
                            <li
                                className=" wow fadeInRight"
                                data-wow-delay="0.6s"
                            >
                                <div className="dropdownOthers">
                                <div className="dropbtn">
                                    <div>Others</div>
                                    <FaChevronDown className="arrowDown"/>
                                </div>

                                <div className="dropdown-content">
                                    <Link to="/careers">Careers</Link>
                                    <Link to="/insurance">Insurance</Link>
                                    <Link to="/store">Store</Link>
                                    <Link to="/second-hand-vehicle">Buy / Sell Vehicle</Link>
                                </div>
                                </div>
                            </li>
                            }

                            {ismobileview ? (
                            <div className="navbar-form navbar-left ">
                                <li
                                    style={{fontSize : "xx-large" , padding : "4.5% 7.5%"}}
                                    // className=" wow fadeInRight"
                                    // data-wow-delay="0.8s"
                                >
                                    {/* <a href="/login"> */}
                                        {/* <img src="../img/user.svg" width="22px" />{" "} */}
                                        <div onClick={() => history.push("/login")}>SignUp / SignIn</div>
                                    {/* </a> */}
                                </li>

                                <div style={{fontSize : "xx-large" , padding : "4.5% 2.5%" , display : "flex" , position : "relative" , width : "90%" , margin : "auto"}}>
                                    <span className="fa fa-search" onClick={()=>{trackDocket()}} style={{
                                        right : "5%" , 
                                        top : "35%" , 
                                        position : "absolute"
                                    }}></span>
                                    <input
                                        type="text"
                                        // className="form-control wow fadeInRight"
                                        // data-wow-delay="0.8s"
                                        style={{width : "100%" , padding : "0%"}}
                                        placeholder="Tracking no."
                                        value={docket}
                                        onChange={(e) => {
                                            setDocketCap(e.target.value);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                trackDocket();
                                            }
                                        }}
                                    />
                                </div>
                                {/* <div style={{fontSize : "xx-large" , padding : "4.5% 2.5%" , display : "flex"}}>
                                    <input
                                        type="text"
                                        // className="trackInputNavbarMobile"
                                        // data-wow-delay="0.8s"
                                        style={{width : "200px"}}
                                        placeholder="Your tracking no."
                                        value={docket}
                                        onChange={(e) => {
                                            setDocketCap(e.target.value);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                trackDocket();
                                            }
                                        }}
                                    />
                                    <button
                                        onClick={trackDocket}
                                        className="btn get-started-track wow fadeInRight"
                                        // data-wow-delay="0.8s"
                                        style={{width : "125px"}}
                                    >
                                        Track
                                    </button>
                                </div> */}
                            </div>) :
                            (<div className="navbar-form navbar-left">
                                <div className="form-group fadeInRight trackInputNavbarWeb">
                                    <span className="fa fa-search track-search-icon" onClick={()=>{trackDocket()}}></span>
                                    <input
                                        type="text"
                                        className="form-control wow fadeInRight"
                                        data-wow-delay="0.8s"
                                        placeholder="Tracking no."
                                        value={docket}
                                        onChange={(e) => {
                                            setDocketCap(e.target.value);
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                trackDocket();
                                            }
                                        }}
                                    />
                                </div>
                            </div>)}
                            
                            {!ismobileview && 
                                <li
                                    className=" wow fadeInRight"
                                    data-wow-delay="0.8s"
                                >
                                    <a href="/login">
                                        <img src="../img/user.svg" width="22px" />{" "}
                                        <span>SignUp / SignIn</span>
                                    </a>
                                </li>
                            }
                            {/* <li className=" wow fadeInRight" data-wow-delay="0.8s">
                <a href="/customerLogin">
                  <img src="../img/user.svg" width="25px" />{" "}
                  <span>Customer Login</span>
                </a>
              </li> */}
                        </ul>
                    </div>

                    {/* <!-- /.navbar-collapse --> */}
                </div>
            </div>
            {/* <!-- /.container --> */}
        </nav>
    );
};

export default withWidth()(withRouter(Header));
